var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3987 11.309L12.7895 10.7212L12.5193 11.0774C13.3248 10.0997 13.8097 8.8304 13.8097 7.44961C13.8097 4.37071 11.418 1.875 8.46734 1.875C5.51672 1.875 3.125 4.37071 3.125 7.44961C3.125 10.5285 5.51672 13.0242 8.46734 13.0242C9.79059 13.0242 11.007 12.5182 11.944 11.6777L11.6026 11.9597L12.1659 12.5954L15.6363 16.2095C15.9849 16.5725 16.5655 16.5722 16.9137 16.2089C17.2416 15.8668 17.2418 15.3272 16.9143 14.9848L13.3987 11.309ZM8.46734 11.309C6.42081 11.309 4.7688 9.58512 4.7688 7.44961C4.7688 5.31411 6.42081 3.59027 8.46734 3.59027C10.5139 3.59027 12.1659 5.31411 12.1659 7.44961C12.1659 9.58512 10.5139 11.309 8.46734 11.309Z",
    fill: "#495052"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.f8437de77f5b4080573e09a6df41caf7.svg";
export { ForwardRef as ReactComponent };